module.exports = __webpack_public_path__ + "static/media/madhuri-webp.8681efbb.webp";